<vi-side-sub-menu [items]="menuItems"
  (itemSelected)="handleSelectPage($event)">
</vi-side-sub-menu>